import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { QRScanner, QRScannerStatus } from '@ionic-native/qr-scanner/ngx';
import { from } from 'rxjs';
import { delay, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class QrCodeService {
  constructor (private originalQrScanner: QRScanner,
    private platform: Platform
  ) {
  }

  private shouldBeMock () {
    return this.platform.is('desktop') || this.platform.is('mobileweb');
  }

  public get qrScanner (): QRScanner {
    if (!this.shouldBeMock()) {
      return this.originalQrScanner;
    } else {
      console.warn('qr code scanner is mocked for browser');
      return {
        prepare (): Promise<any> {
          return Promise.resolve();
        },
        scan () {
          return from(['https://test.arian.ee/28408,6ohswjthzrhl'])
            .pipe(
              delay(1000),
              take(1));
        },
        destroy () { },
        show () {

        },
        hide () {

        },
        getStatus (): Promise<QRScannerStatus> {
          return Promise.resolve({
            authorized: true,
            denied: true,
            restricted: true,
            prepared: true,
            showing: true,
            scanning: true,
            previewing: true,
            lightEnabled: true,
            canOpenSettings: true,
            canEnableLight: true,
            canChangeCamera: true,
            currentCamera: 2
          });
        }
      } as QRScanner;
    }
  }
}
